module.exports = "/_next/static/videos/2-3502ea688bf910766b4685f25e9923fb.webm";